import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.replace(/\/+$/, "");

export const API_URL = BACKEND_URL
  ? (BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`)
  : (process.env.NODE_ENV === 'production' 
      ? 'https://evotaxi-backend.onrender.com/api' 
      : '/api');

export const API_TIMEOUT_MS = 15000;
export const SLOW_API_MS = 6000;

// Format money as XAF
export function formatXAF(amount) {
  if (amount === null || amount === undefined) return "0 XAF";
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount) + " XAF";
}

// Format date as DD/MM/YYYY
export function formatDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

// Format date as YYYY-MM-DD in local time
export function toLocalISO(date) {
  if (!date) return "";
  return date.getFullYear() + '-' + 
    String(date.getMonth() + 1).padStart(2, '0') + '-' + 
    String(date.getDate()).padStart(2, '0');
}

// Get today's date in YYYY-MM-DD format
export function getTodayISO() {
  return toLocalISO(new Date());
}

// Get first day of current month in YYYY-MM-DD format
export function getMonthStartISO() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
}

// Get last day of current month in YYYY-MM-DD format
export function getMonthEndISO() {
  const now = new Date();
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return toLocalISO(lastDay);
}

// Status color helper
export function getStatusColor(status) {
  switch (status) {
    case 'activo':
      return 'text-emerald-600';
    case 'mantenimiento':
      return 'text-amber-600';
    case 'inactivo':
      return 'text-slate-500';
    default:
      return 'text-muted-foreground';
  }
}

// Status badge class helper
export function getStatusBadgeClass(status) {
  switch (status) {
    case 'activo':
      return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    case 'mantenimiento':
      return 'bg-amber-100 text-amber-700 border-amber-200';
    case 'inactivo':
      return 'bg-slate-100 text-slate-700 border-slate-200';
    default:
      return 'bg-muted text-muted-foreground';
  }
}
